import { memo } from "react";
import { Box, Divider, Grid, Theme, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";

import useDialog from "hooks/useDialog";
import { colors } from "theme";

import ForgotPasswordForm from "./ForgotPasswordForm";
// import ReactivateForm from "./ReactivateForm";

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    background: colors.grey[400],
  },
  gridItem: {
    flex: "1 1 0",
  },
}));

const AccountRecoveryForm = () => {
  const classes = useStyles();
  const { openAccountRecoveryDialog } = useDialog();
  const inNarrowMode =
    useMediaQuery((theme: Theme) => theme.breakpoints.down('md')) ||
    openAccountRecoveryDialog;

  return (
    <Grid
      container
      direction={inNarrowMode ? "column" : "row"}
      alignItems={inNarrowMode ? "center" : "flex-start"}
    >
      <Grid item className={classes.gridItem} xs={12}>
        <Box py={{ md: 3 }}>
          <ForgotPasswordForm />
        </Box>
      </Grid>
      <Box
        mx={inNarrowMode ? 0 : 4.5}
        my={inNarrowMode ? 4 : 0}
        alignSelf="stretch"
      >
        <Divider
          orientation={inNarrowMode ? "horizontal" : "vertical"}
          className={classes.divider}
        />
      </Box>
      <Grid item className={classes.gridItem} xs={12}>
        {/* <ReactivateForm /> */}
      </Grid>
    </Grid>
  );
};

export default memo(AccountRecoveryForm);
